import Navbar from "../../layout/Navbar"
import Banner from '../../assets/images/ecomm-banner.png'
import HomeSearch from "../../components/elements/HomeSearch"
import SearchCapsules from "../../components/elements/SearchCapsules"
import ProductCard from "../../components/cards/ProductCard"

export default () => {
    return(
        <>
            <Navbar />
            <section className="">
                <div className="d-flex justify-content-center align-items-end" style={{ height: "100vh", background: `url(${Banner})` }}>
                    <div className="mb-5 pb-5">
                        <div className="namaste mb-4">Authentic Indian Heritage</div>
                        <HomeSearch />
                        <p className="bold text-white text-center fs-4 my-4">Recent Searches</p>
                        <div className="d-flex flex-wrap container">
                            <SearchCapsules />
                            <SearchCapsules />
                            <SearchCapsules />
                            <SearchCapsules />
                            <SearchCapsules />
                        </div>
                    </div>
                </div>
            </section>

            <section className="products container">
                <div className="d-flex mt-5 pt-5">
                    <h3 className="custom-text-color me-4">Your Best Products</h3>
                    <select className="form-control w-25" style={{ borderRadius: "20px" }}>
                        <option>Sort By: Most Relevant</option>
                        <option>Sort By: high to low</option>
                    </select>
                </div>

                <div className="row mt-4">
                    {
                        Array(12).fill(0).map(_ =>
                            <div className="col-lg-3 col-md-6 col-sm-12 px-0">
                                <ProductCard />
                            </div>
                        )
                    }
                </div>
            </section>
        </>
    )
}